<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible">
        <el-form label-position="top" :model="form" :rules="rules" ref="dialogForm">
            <el-form-item label="书籍ID:" prop="book_ids">
                <el-input
                    type="textarea"
                    :rows="5"
                    v-model.trim="form.book_ids"
                    placeholder="请输入书籍ID,多个ID间用英文逗号隔开"
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="addList">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import QuRequest from '@/core/QuRequest';

const quRequest = new QuRequest();

export default {
    props: {
        setApi: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            title: '加入白名单',
            type: '',
            form: {
                book_ids: ''
            },
            rules: {
                book_ids: [{ required: true, message: '请填写书籍id', trigger: 'blur' }]
            },
            dialogFormVisible: false
        };
    },
    methods: {
        showDialog (type, title) {
            this.type = type;
            this.form.book_ids = '';
            this.title = title || '加入白名单';
            this.dialogFormVisible = true;
        },
        hideDialog () {
            this.dialogFormVisible = false;
        },
        addList () {
            this.$refs['dialogForm'].validate(valid => {
                if (valid) {
                    let that = this;
                    quRequest
                        .send(this.setApi, {
                            book_ids: that.form.book_ids,
                            product_key: 'midu',
                            app_key: 'story'
                        })
                        .then(res => {
                            this.$emit('close', that.type);
                            this.hideDialog();
                            this.$message.success(res.message);
                        })
                        .catch(err => {
                            this.$emit('close', that.type);
                            this.hideDialog();
                            this.$message.error(err.message);
                        });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
